import {
  mobile,
  backend,
  creator,
  web,
  javascript,
  typescript,
  reactjs,
  redux,
  tailwind,
  nodejs,
  mongodb,
  git,
  meta,
  starbucks,
  tesla,
  shopify,
  carrent,
  jobit,
  tripguide,
  threejs,
  sass,
  react,
  mredux,
} from '../Assets/index.js'

export const navLinks = [
  {
    id: 'about',
    title: 'About',
  },
  {
    id: 'work',
    title: 'Work',
  },
  {
    id: 'contact',
    title: 'Contact',
  },
]

const services = [
  {
    title: 'Web Developer',
    icon: web,
  },
  {
    title: 'React Native Developer',
    icon: mobile,
  },
  {
    title: 'Backend Developer',
    icon: backend,
  },
  {
    title: 'Mobile Developer',
    icon: creator,
  },
]

const technologies = [
  {
    name: 'JavaScript',
    icon: javascript,
  },
  {
    name: 'TypeScript',
    icon: typescript,
  },
  {
    name: 'React JS',
    icon: react,
  },
  {
    name: 'Redux Toolkit',
    icon: redux,
  },
  {
    name: 'Tailwind CSS',
    icon: tailwind,
  },
  {
    name: 'Node JS',
    icon: nodejs,
  },
  {
    name: 'MongoDB',
    icon: mongodb,
  },
  {
    name: 'Three JS',
    icon: threejs,
  },
  {
    name: 'git',
    icon: git,
  },
]

const technologiesHome = [
  {
    name: 'Node JS',
    icon: nodejs,
  },
  {
    name: 'React JS',
    icon: reactjs,
  },
  {
    name: 'TypeScript',
    icon: typescript,
  },
]

const heroImg = { sass, react, mredux }
const experiences = [
  {
    title: 'React.js Developer',
    company_name: 'Freelance',
    icon: starbucks,
    iconBg: '#383E56',
    date: 'Feb 2021 – June 2021',
    points: [
      'Built UI components in React.js to digitize the process of global communication.',
      'Designed and implemented data models in Javascript to model various processes in global communication especially data fetching based on user preference (likes, comments, search and more)',
    ],
  },
  {
    title: 'Web Developer',
    company_name: 'Cytitan',
    icon: shopify,
    iconBg: '#383E56',
    date: 'August 2022',
    points: [
      'Developing and maintaining web applications using React.js and other related technologies.',
      'Collaborating with cross-functional teams including designers, product managers, and other developers to create high-quality products.',
      'Implementing responsive design and ensuring cross-browser compatibility.',
      'Participating in code reviews and providing constructive feedback to other developers.',
      'Automated database backup and encryption Cron job using AWS.',
    ],
  },
  {
    title: 'Full stack developer',
    company_name: 'Freelance',
    icon: tesla,
    iconBg: '#E6DEDD',
    date: 'October 2022 - January 2023',
    points: [
      ' Developed backend for a cryptocurrency application using Node.js and Express.js, with MongoDB as the database.',
      'Integrated block chain technology for secure transactions and smart contract functionality.',
      'Implemented cryptocurrency wallet management, including key generation and transaction handling.',
      'Integrated payment gateways for seamless cryptocurrency-to-fiat transactions.',

      ' Implemented robust authentication and encryption for secure access and data protection.',
      'Developed RESTful APIs and comprehensive documentation.',
      'Utilized MongoDB for efficient storage and retrieval of cryptocurrency-related data.',
      'Integrated third-party exchanges and APIs for real-time market data.',
      ' Conducted testing, debugging, and performance optimization for scalability.',
    ],
  },

  {
    title: 'Mechatronic Research Group',
    company_name: 'Software Engineering Student/Fellow/Intern',
    icon: meta,
    iconBg: '#E6DEDD',
    date: 'March 2023',
    points: [
      'Applied computer science data structures and algorithms to solve computational problems ensuring the data flow within a finite amount of space and time',
      'Gained hands-on experience with Javascript, Reactjs, Tensorflow and Pytourch APIs and tech principles whilst working on team projects, code reviews, and pair programming session',
      'Participating in code reviews and providing constructive feedback to other developers.',
    ],
  },
];

const testimonials = [
  {
    testimonial:
      'I thought it was impossible to make a website as beautiful as our product, but Asogwa Chinedu proved me wrong.',
    name: 'Dr. Ozoemmna Ani.',
    designation: 'HOD department of mechatronic engr. UNN',
    company: 'Acme Co',
    image: 'https://randomuser.me/api/portraits/women/4.jpg',
  },
  {
    testimonial:
      "I've never met a web developer who truly cares about their clients' success like sanctus does.",
    name: 'Okeafor John',
    designation: 'COO',
    company: 'Crowd Founder',
    image: 'https://randomuser.me/api/portraits/men/5.jpg',
  },
  {
    testimonial:
      "After christsanctus optimized our website, our traffic increased by 50%. We can't thank them enough!",
    name: 'Mosira Kesibari',
    designation: 'CEO',
    company: 'CEO cryptitan',
    image: 'https://randomuser.me/api/portraits/women/6.jpg',
  },
];

const projects = [
  {
    name: 'Project Blog social Media Application',
    description:
      'Web-based platform that allows users to search, like, and comment just to mention a feew on post providing a convenient and efficient solution for entertainment needs.',
    tags: [
      {
        name: 'react',
        color: 'blue-text-gradient',
      },
      {
        name: 'mongodb',
        color: 'green-text-gradient',
      },
      {
        name: 'Material ui',
        color: 'pink-text-gradient',
      },
    ],
    image: carrent,
    source_code_link:
      'https://github.com/sherlockholms221B/Mern-blog-social-media-application',
  },
  {
    name: 'Mefriends',
    description:
      'Web application that enables users to search for user, view estimated post ranges for positions, like, comment, real time chat and notification with sokect.io.',
    tags: [
      {
        name: 'react',
        color: 'blue-text-gradient',
      },
      {
        name: 'restapi',
        color: 'green-text-gradient',
      },
      {
        name: 'scss',
        color: 'pink-text-gradient',
      },
    ],
    image: jobit,
    source_code_link:
      'https://github.com/sherlockholms221B/FacebookClone-Web-Application',
  },
  {
    name: 'Trip Guide',
    description:
      'A comprehensive travel booking platform that allows users to book flights, hotels, and rental cars, and offers curated recommendations for popular destinations.',
    tags: [
      {
        name: 'nextjs',
        color: 'blue-text-gradient',
      },
      {
        name: 'supabase',
        color: 'green-text-gradient',
      },
      {
        name: 'css',
        color: 'pink-text-gradient',
      },
    ],
    image: tripguide,
    source_code_link: 'https://github.com/',
  },
];

export {
  services,
  technologies,
  experiences,
  testimonials,
  projects,
  technologiesHome,
  heroImg,
}
